import moment from 'moment-timezone';
import {
    API_DATE_FORMAT, API_TIME_FORMAT, DISPLAY_DATE_FORMAT, DISPLAY_TIME_FORMAT,
    DISPLAY_DATETIMESECONDS_WITHOUT_YEAR_FORMAT2, DISPLAY_DATETIMESECONDS_FORMAT2,
    DISPLAY_DATETIME_WITHOUT_YEAR_FORMAT2, DISPLAY_DATETIME_FORMAT2, GRAPH_INPUT_DATE_FORMAT,
    DISPLAY_DATE_FORMAT2, DISPLAY_DATE_FORMAT3
} from '../constants';

export const parseDate = (date) => {
    return new Date(date);
}

export const getLocalDate = () => {
    return moment(new Date());
}

export const getUTC = () => {
    return moment.utc();
}

export const getDefaultMoment = () => {
    return moment.utc("1970-01-01");
}

export const toMoment = (date, isUTC = true) => {
    return isUTC ? moment.utc(date) : moment(date);
}

export const toApiDateString = (date, time = true) => {
    if (!date) return date;
    if (typeof date === "string") {
        if (time) return date ? moment(date).format(`${API_DATE_FORMAT} ${API_TIME_FORMAT}`) : "";
        else return date ? moment(date).format(`${API_DATE_FORMAT}`) : "";
    } else {
        if (time) return date ? date.format(`${API_DATE_FORMAT} ${API_TIME_FORMAT}`) : "";
        else return date ? date.format(`${API_DATE_FORMAT}`) : "";
    }
}

export const toDisplayDateString = (date, time = true) => {
    if (typeof date === "string") {
        if (time) return date ? moment.utc(date).format(`${DISPLAY_DATE_FORMAT} ${DISPLAY_TIME_FORMAT}`) : "";
        else return date ? moment.utc(date).format(`${DISPLAY_DATE_FORMAT}`) : "";
    } else {
        if (time) return date ? date.format(`${DISPLAY_DATE_FORMAT} ${DISPLAY_TIME_FORMAT}`) : "";
        else return date ? date.format(`${DISPLAY_DATE_FORMAT}`) : "";
    }
}

export const toDisplayDateTimeString = (date, currentYear = true, withSeconds = false) => {
    const format = withSeconds ?
        currentYear ? DISPLAY_DATETIMESECONDS_WITHOUT_YEAR_FORMAT2 : DISPLAY_DATETIMESECONDS_FORMAT2
        : currentYear ? DISPLAY_DATETIME_WITHOUT_YEAR_FORMAT2 : DISPLAY_DATETIME_FORMAT2;
    if (typeof date === "string") return date ? moment.utc(date).format(`${format}`) : "";
    else return date ? date.format(`${format}`) : "";
}

export const toDisplayDateTimeString2 = (date, currentYear = true, withTime = false) => {
    const format = currentYear ? DISPLAY_DATE_FORMAT3 : DISPLAY_DATE_FORMAT2;
    if (typeof date === "string") return date ? moment.utc(date).format(`${format}`) : "";
    else return date ? date.format(`${format}`) : "";
}

export const toDisplayTimeString = (number) => {
    let time = { d: 0, h: 0, m: 0 };
    let timeStr = [];

    if (typeof number !== 'undefined' && number.length > 0 && !isNaN(number)) {
        if (number.indexOf(".") >= 0) {
            const arr = number.split(".");
            if (number.hasOwnProperty('d')) {
                time.d = parseInt(arr[0]);
                time.h = parseInt(arr[1]);
                time.m = parseInt(arr[2]);
            }
            else {
                time.h = parseInt(arr[0]);
                time.m = parseInt(arr[1]);
            }
        } else time.h = parseInt(number);
    } else if (typeof number === 'object' && number.hasOwnProperty('h') && number.hasOwnProperty('m')) {
        time = number;
    }

    if (time.d > 0 || time.h > 0 || time.m > 0 || time.s > 0) {
        if (time.d > 0) timeStr.push(time.d + 'd');
        if (time.h > 0) timeStr.push(time.h + 'h');
        if (time.m > 0) timeStr.push(time.m + 'm');
        if (time.s > 0) timeStr.push(time.s + 's');
    } else timeStr = ['0'];

    return timeStr.join(' ');
}

export const toDigitalTime = (timeInSeconds, withSeconds = false) => {
    const pad = (num, size) => ('000' + num).slice(size * -1);

    const time = parseFloat(timeInSeconds).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60);

    const meridian = (hours >= 12) ? 'pm' : 'am';
    const hrs = (hours - 12 > 0) ? (hours - 12) : (hours === 0) ? 12 : hours;

    return pad(hrs, 2) + ':' + pad(minutes, 2)
        + (withSeconds ? ':' + pad(seconds, 2) : '')
        + (' ' + meridian);
}

export const secondsToTime = (seconds, withSeconds = false, withDay = false) => {
    let n = Number(seconds);
    if (withDay) {
        const days = Math.floor(n / (24 * 3600));
        n -= days * 24 * 3600;
        return {
            d: days,
            h: Math.floor(n / 3600),
            m: Math.floor(n % 3600 / 60),
            s: Math.floor(n % 3600 % 60)
        };
    }
    else if (withSeconds) {
        return {
            h: Math.floor(n / 3600),
            m: Math.floor(n % 3600 / 60),
            s: Math.floor(n % 3600 % 60)
        };
    } else {
        return {
            h: Math.floor(n / 3600),
            m: Math.floor(n % 3600 / 60)
        };
    }
}

export const timeToSeconds = time => ((time.h ? (time.h * 3600) : 0) + (time.m ? (time.m * 60) : 0));

export const dateDiff = (datepart, fromDate, toDate) => {
    datepart = datepart.toLowerCase();
    const str = {
        w: 'weeks',
        d: 'days',
        h: 'hours',
        m: 'minutes',
        s: 'seconds'
    };
    return str.hasOwnProperty(datepart) ? moment.utc(fromDate).diff(moment.utc(toDate), str[datepart]) : 0;
}

export const dateAdd = (date, amount, unit) => {
    return moment(date).add(amount, unit);
}

export const dateToUTC = (date, timezone) => {
    if (!timezone) return moment.utc(date);
    const tzDate = moment.utc(date).tz(timezone);
    const offset = tzDate.utcOffset() * -1;
    return moment.utc(date).add(offset, "minutes");
}


export const dateUTCToTimezone = (date, timezone) => {
    if (!timezone) return moment.utc(date);
    return moment.utc(date).tz(timezone);
}

export const toCustomDate = (from, to) => {
    return {
        from: moment(from).format(`${API_DATE_FORMAT} ${API_TIME_FORMAT}`),
        to: moment(to).format(`${API_DATE_FORMAT} ${API_TIME_FORMAT}`)
    };
}

export const graphDateString = momentDate => momentDate.format(GRAPH_INPUT_DATE_FORMAT);